const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';

const selectors = {
  button: '.prod_wishlist',
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button);
  if (!buttons.length) return;

  // console.log(buttons);

  buttons.forEach((button) => {
    // console.log(button);
    // Extract product data from button attributes
    const productHandle = button.dataset.productHandle || false;
    const productUrl = button.dataset.productUrl || '';
    const productTitle = button.dataset.productTitle || '';
    const productImage = button.dataset.productImage || '';

    // Create a product info object
    const productInfo = {
      handle: productHandle,
      url: productUrl,
      title: productTitle,
      image: productImage,
    };

    // Check if product is already in the wishlist
    let storedWishlist =
      JSON.parse(localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY)) || [];
    if (storedWishlist.some((item) => item.handle === productHandle)) {
      button.classList.add('active');
    }

    // Add click event listener to the button
    button.addEventListener('click', (event) => {
      event.stopPropagation(); // Prevent the event from bubbling up to the <a> tag
      event.preventDefault(); // Prevent the default action of the <a> tag

      const isActive = button.classList.toggle('active');
      if (isActive) {
        addToWishlist(productInfo);
      } else {
        removeFromWishlist(productHandle);
      }
    });
  });
};

const addToWishlist = (productInfo) => {
  let storedWishlist =
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY)) || [];
  if (!storedWishlist.some((item) => item.handle === productInfo.handle)) {
    storedWishlist.push(productInfo);
    localStorage.setItem(
      LOCAL_STORAGE_WISHLIST_KEY,
      JSON.stringify(storedWishlist)
    );
  }
  renderWishlist(); // Update the wishlist display
};

const removeFromWishlist = (productHandle) => {
  let storedWishlist =
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY)) || [];
  const updatedWishlist = storedWishlist.filter(
    (item) => item.handle !== productHandle
  );
  localStorage.setItem(
    LOCAL_STORAGE_WISHLIST_KEY,
    JSON.stringify(updatedWishlist)
  );
  renderWishlist(); // Update the wishlist display
};

const renderWishlist = () => {
  const wishProdWrap = document.querySelector('.wish_prod_list');
  if (!wishProdWrap) return;

  wishProdWrap.innerHTML = '';

  const storedWishlist =
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY)) || [];

  if (storedWishlist.length === 0) {
    wishProdWrap.innerHTML = 'Nothing here yet! <br/> Wishlist items you love to keep track of them.';
    wishProdWrap.classList.add('empty');
  } else {
    storedWishlist.forEach((item) => {
    const productDiv = document.createElement('a');
    productDiv.className = 'wishlist-product';
    productDiv.href = item.url;

    const imageContainer = document.createElement('div');
    imageContainer.className = 'image-container';

    const productImage = document.createElement('img');
    productImage.src = item.image;
    productImage.alt = item.title;

    const removeButton = document.createElement('button');
    removeButton.className = 'remove-wishlist-item';
    removeButton.innerHTML = `
     <div class="remove-bookmark">
     Remove
    </div>
      `;
    removeButton.onclick = (e) => {
      e.preventDefault(); // Prevents the link from navigating
      removeItemFromWishlist(item.handle);
    };

    imageContainer.appendChild(productImage);
    imageContainer.appendChild(removeButton);
    productDiv.appendChild(imageContainer);

    const productTitle = document.createElement('h3');
    productTitle.textContent = item.title;

    productDiv.appendChild(productTitle);
    wishProdWrap.appendChild(productDiv);
  });
  }
};

const removeItemFromWishlist = (productHandle) => {
  let storedWishlist =
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY)) || [];
  storedWishlist = storedWishlist.filter(
    (item) => item.handle !== productHandle
  );
  localStorage.setItem(
    LOCAL_STORAGE_WISHLIST_KEY,
    JSON.stringify(storedWishlist)
  );
  renderWishlist(); // Re-render the wishlist to update the UI
};

window.onload = () => {
  initButtons();
  renderWishlist(); // This will render the wishlist items if they exist in localStorage
};
